import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { RootProvider } from './providers/RootProvider'

// Prefetch strategy
const prefetchRoutes = () => {
  // Prefetch main routes after initial load
  window.addEventListener('load', () => {
    // Wait for main content to load
    setTimeout(() => {
      const links = [
        '/learn/',
        '/practice/',
        '/about/',
        '/biases/'
      ];

      links.forEach(link => {
        const prefetchLink = document.createElement('link');
        prefetchLink.rel = 'prefetch';
        prefetchLink.href = link;
        document.head.appendChild(prefetchLink);
      });
    }, 1000);
  });
};

// Wrapper component to handle rendering completion
const AppWithRenderEvent = () => {
  useEffect(() => {
    // Use requestIdleCallback or setTimeout to ensure the app is fully rendered
    const notifyRendered = () => {
      console.log('App fully rendered, dispatching app-rendered event');
      // Dispatch the app-rendered event
      document.dispatchEvent(new Event('app-rendered'));
    };

    // Use requestIdleCallback if available, otherwise setTimeout
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(notifyRendered, { timeout: 1000 });
    } else {
      setTimeout(notifyRendered, 1000);
    }
  }, []);

  return <App />;
};

// Initialize app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootProvider>
      <AppWithRenderEvent />
    </RootProvider>
  </StrictMode>,
)

// Start prefetching
prefetchRoutes();
